module.exports = __webpack_public_path__ + "img/major8.03992cf4.png";